import * as z from "zod";

const DeviationBaseSchema = z.object({
  description: z.string().min(1, "required"),
  contractDeviationTypeId: z.number(),
  amount: z.string().optional(),
  image: z.array(z.instanceof(File)).optional(),
});

export const DeviationSchema = DeviationBaseSchema;
export type DeviationFormInput = z.infer<typeof DeviationSchema>;
